import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import purityService from "./purityService";

export const getPurity = createAsyncThunk(
  "purity/all",
  async (thunkAPI) => {
    try {
      return await purityService.getPurities();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAPurity = createAsyncThunk(
  "purity/get",
  async (id, thunkAPI) => {
    try {
      return await purityService.getPurity(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createPurity = createAsyncThunk(
  "purity/add",
  async (purityData, thunkAPI) => {
    try {
      return await purityService.createPurity(purityData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAPurity = createAsyncThunk(
  "purity/edit",
  async (purity, thunkAPI) => {
    try {
      return await purityService.updatePurity(purity);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAPurity = createAsyncThunk(
  "purity/delete",
  async (id, thunkAPI) => {
    try {
      return await purityService.deletePurity(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  Purity: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const PuritySlice = createSlice({
  name: "Purity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPurity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPurity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Purity = action.payload.data;
        console.log("Fetched Purity:", action.payload.data);
      })
      .addCase(getPurity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPurity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPurity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPurity = action.payload;
      })
      .addCase(createPurity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAPurity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAPurity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.purityName = action.payload.result.product_purity;
        state.metalName = action.payload.result.metal_type?._id || "";
      })
      .addCase(getAPurity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAPurity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAPurity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedPurity = action.payload;
      })
      .addCase(updateAPurity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAPurity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAPurity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedPurity = action.payload;
      })
      .addCase(deleteAPurity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default PuritySlice.reducer;
